import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useStudentPayments() {
  return useQuery({
    queryKey: ["student", "payments"],
    queryFn: async () => {
      const res = await apiClient.get("/api/v1/me/student/payments/");
      return res.data;
    },
  });
}

export { useStudentPayments };
